import { createRoot } from 'react-dom/client'
import { AuthProvider } from 'react-oidc-context'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App'
import settings from './auth'
import { persistor, store } from './store'
import 'tippy.js/dist/tippy.css'
import './customer/customValidators'
import { getRouterBasename } from './routes/utils'
import 'react-virtualized/styles.css'

const container = document.getElementById('root')
const root = createRoot(container!)
const basename = getRouterBasename()

root.render(
  // Allow prop spreading for AuthProvider to keep the settings in one place
  // eslint-disable-next-line react/jsx-props-no-spreading
  <AuthProvider {...settings}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename={basename}>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </AuthProvider>
)
